/**
 * Created by shaik on 11/06/17.
 */
define(function (require) {

    var BaseController = require('web-agent-assets-js/BaseController');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////


    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    var AgentDataManager = BaseController.extend(function agentDataManager(options) {
        if (options) {
            this.model = options.model;
        }
        setACUserDataToModel.call(this);
        setAgentsInGroupToModel.call(this);
    });

    function setACUserDataToModel() {
        this.LoggedInUserModel = _getLoggedInUserModel();

        // If we're running after the first fetch - get the current data so we don't wait for the next fetch
        if (this.LoggedInUserModel.getFetchState() === this.LoggedInUserModel.FetchState.SUCCESS) {
            _updateAgentModelKeys.call(this);
        }
        else {
            // bind to changes on the required properties in the data module (employeeId and agentGroupId)
            this.LoggedInUserModel.listenToOnce(this.LoggedInUserModel, "fetch:success", function() {
                _updateAgentModelKeys.call(this);
            }.bind(this));
        }
    }

    function setAgentsInGroupToModel() {
        this.agentModel = _getAgentsInSameGroup();

        // If we're running after the first fetch - get the current data so we don't wait for the next fetch
        if (this.agentModel.getFetchState() === this.agentModel.FetchStateEnum.SUCCESS) {
            _agentsUpdate.call(this);
        }
        else {
            // bind to changes on agentsInGroup in the data module
            this.agentModel.listenTo(this.agentModel, "fetch:success", _agentsUpdate.bind(this));
        }
    }
    /**
     * Return the data module
     * @returns {*}
     * @private
     */
    function _getLoggedInUserModel() {
        return LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLoggedInUserModel);
    }

    function _getAgentsInSameGroup() {
        return LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentsInSameGroup);
    }

    function _updateAgentModelKeys() {
        _agentPidUpdate.call(this);
        _employeeIdUpdate.call(this);
        _agentGroupIdUpdate.call(this);
        _agentEmailUpdate.call(this);
        _updateOperatorDetails.call(this);
    }

    function _agentPidUpdate() {
        var pid = this.LoggedInUserModel.getPid();
        this.model.set("agent.pid", pid);
    }

    function _employeeIdUpdate() {
        var employeeId = this.LoggedInUserModel.getEmployeeId();
        this.model.set("agent.employeeId", employeeId);
    }

    function _agentEmailUpdate() {
        var agentEmail = this.LoggedInUserModel.getEmail();
        this.model.set("agent.emailAddress", agentEmail);
    }

    function _agentGroupIdUpdate() {
        var agentGroupId = this.LoggedInUserModel.getMemberOfGroup();
        this.model.set("agent.agentGroupId", agentGroupId);
    }

    function _updateOperatorDetails(){
        var loggedInUser = this.LoggedInUserModel.toJSON();
        loggedInUser.agentGroupId = this.LoggedInUserModel.getMemberOfGroup();
        loggedInUser.skillIds = this.LoggedInUserModel.getSkills();
        this.model.set('operators.loggedInUser', loggedInUser);
    }

    function _agentsUpdate() {
        var agentsArray = this.getAgentNames();
        this.model.modify("operators.inGroupArray", agentsArray, "id");
    }

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////

    AgentDataManager.prototype.applicationType = 'AgentDataManager';

    /**
     * Return array of agent name that the agent can filter by
     * @returns {Array[{id,fullName,displayName,agentGroupId,skillIds,nickname,deleted}]}
     */
    AgentDataManager.prototype.getAgentNames = function () {
        var agentsObj = this.agentModel.toJSON();
        var agentsArray = [];
        $.each(agentsObj, function(i, item){
            var agentGroupId = (item.memberOf) ? item.memberOf.agentGroupId : null;
            agentsArray.push({
                id: item.id + "",
                pid: item.pid,
                fullName: item.fullName,
                displayName: item.fullName,
                agentGroupId: agentGroupId,
                skillIds: item.skillIds,
                nickname: item.nickname,
                deleted: item.deleted
            });
        });
        return agentsArray;
    };

    return AgentDataManager;

});
